export default {
    link: {
        color: 'rgb(220 59 63)'
    },
    boldLink: {
        color: 'rgb(220 59 63)',
        fontWeight: 'bold'
    },
    savedCardHeader: {
        background: 'var(--silver)',
        color: 'var(--dark-grey)'
    },
    savedCard: {
        background: '#fff'
    }
};
